<div class="sabis-chatbot-popup" [ngClass]="customCssClass" tabindex="-1">
    <!-- actions buttons, messages list, input -->
    <section class="right-side">
        <section>
            <!-- history section -->
            @if(isHistoryTabVisible) {
            <section class="history-section">
                <sabis-history-side-panel [isCollapsed]="isHistoryPanelCollapsed"
                    [activeSessionId]="historyActiveSessionId()" [isReadyToLoad]="isHistoryReadyToLoad()"
                    (chatSelected)="onHistorySessionSelected($event)"></sabis-history-side-panel>
            </section>
            }
            <section class="actions-container">
                <button (click)="onNewChat()" class="new-chat-button"
                    [disabled]="isNewChatDisabled || !canStartNewSession">
                    New Chat
                    @if (isNewChatDisabled || !canStartNewSession) {
                    <img src="assets/icons/new-chat-icon-disabled.png" alt="New Chat Button" />
                    } @else {
                    <img src="assets/icons/new-chat-icon.png" alt="New Chat Button" />
                    }
                </button>

                @if(chatbotConfig.isMinimizeButtonVisible) {
                <button class="minimize-button" (click)="toggleMinimize()">
                    <img class="minimize-img" src="assets/icons/minimize-icon.png" alt="Minimize Button" />
                </button>
                }
                @if(chatbotConfig.isCloseButtonVisible) {
                <button class="close-button" (click)="attemptCloseChatbot()">
                    <img class="close-img" src="assets/icons/close-icon.png" alt="Close Button" />
                </button>
                }
            </section>
        </section>

        <sabis-chatbot  [selectedHistorySessionId]="selectedHistorySessionId"
            [isSessionIdVisible]="isSessionIdVisible"
            (connectionEstablished)="onConnectionEstablished($event)"
            (contentClick)="onContentClick($event)" />
    </section>
</div>